import React from "react";
import { FormFactory, InputJson } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import InputFactory from "../../../../components/InputFactory";
import EmployeeFormPresenter from "../../../HumanResource/Employees/employee-form/EmployeeFormPresenter";

class JobApplicantsView extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      questionOne: false,
      questionTwo: false,
      questionThree: false,
      questionFour: false,
      questionFive: false,
      questionSix: false,
      questionSeven: false,
      questionEight: false,
      questionNine: false,
      questionTen: false,
      questionEleven: false,
      questionTwelve: false,
    };
    this.presenter = new EmployeeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return "job_applicants";
  }

  handleToggleState = (key) => {
    this.setState((prevState) => ({ [key]: !prevState[key] }));
  };

  toggleItemChildList = (question, fieldState, field, object, options = {}) => {
    return this.presenter.toggleItemChildList(
      question,
      fieldState,
      field,
      object,
      options,
    );
  };

  toggleItemParentList = (
    question,
    fieldState,
    field,
    object,
    options = {},
  ) => {
    return this.presenter.toggleItemParentList(
      question,
      fieldState,
      field,
      object,
      options,
    );
  };

  hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    if (value instanceof Date) return !Number.isNaN(value.getTime());
    if (typeof value === "object") return Object.keys(value).length > 0;
    return true;
  };

  setObject(object) {
    const keys = [
      "questionOne",
      "questionTwo",
      "questionThree",
      "questionFive",
      "questionSix",
      "questionSeven",
      "questionEight",
      "questionNine",
      "questionTen",
      "questionEleven",
      "questionTwelve",
    ];
    const next = keys.reduce(
      (acc, k) => {
        if (this.hasValue(object?.[k])) acc[k] = true;
        return acc;
      },
      { object },
    );

    if (
      this.hasValue(object?.questionFour) ||
      this.hasValue(object?.questionFourDate) ||
      this.hasValue(object?.questionFourStat)
    ) {
      next.questionFour = true;
    }

    this.setState(next);
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    // const certificates = [
    //   "Diploma",
    //   "eligibilityCertificate",
    //   "trainingCertificate",
    //   "experienceCertificate",
    //   "birthCertificate",
    //   "nbiCertificate",
    //   "socialCertificate",
    //   "medicalCertificate",
    // ];

    const attachementsFields = [
      "personalDataSheet",
      "copiesOfCertificatedEligibilities",
      "copiesOfDiploma",
      "tor",
      "letterOfIntent",
      "idPicture",
    ];

    // const certificateFields = attachementsFields?.reduce((result, key) => {
    //   if (object[key] !== undefined) {
    //     result[key] = object[key]; // Only add to the result if the key exists in the object
    //   }
    //   return result;
    // }, {});

    const viewDisabled = true;
    const qDefs = [
      {
        kind: "child",
        key: "questionOne",
        label: "A. within the third degree?",
      },
      {
        kind: "child",
        key: "questionTwo",
        label:
          "B. within the fourth degree (for Local Government Unit - Career Employees)?",
      },
      {
        kind: "parent",
        key: "questionThree",
        label:
          "A. Have you ever been found guilty of any administrative offense?",
      },
      {
        kind: "parent",
        key: "questionFive",
        label:
          "Have you even been convicted of any crime or violation of any law, decree, ordinance or regulation by any court of tribunal?",
      },
      {
        kind: "parent",
        key: "questionTwelve",
        label:
          "Have you even been separated from the service in any of the following modes: resignation, retirement, dropped from the rolls, dismissal, termination, end of term, finished contract or phased out (abolition) in the public or private sector?",
      },
      {
        kind: "parent",
        key: "questionSix",
        label:
          "A. Have you ever been a candidate in a national or local election held within the last year (except Barangay election)?",
      },
      {
        kind: "parent",
        key: "questionSeven",
        label:
          "B. Have you resigned from the government service during the three (3)-month period before the last election to promote/actively campaign for a national or local candidate?",
      },
      {
        kind: "parent",
        key: "questionEight",
        label:
          "Have you acquired the status of an immigrant or permanent resident of another country?",
      },
      {
        kind: "child",
        key: "questionNine",
        label: "a. Are you a member of any idigenous group?",
      },
      {
        kind: "child",
        key: "questionTen",
        label: "b. Are you a person with disability?",
      },
      {
        kind: "child",
        key: "questionEleven",
        label: "c. Are you a solo parent?",
      },
    ];

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                {/* <form onSubmit={this.onSubmitForm.bind(this)}> */}
                <div className="row g-3">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-muted small">User:</span>
                        <span className="badge bg-primary rounded-pill px-3 py-2">
                          {object?.user?.username || "N/A"}
                        </span>
                      </div>
                      <FormFactory
                        schema={schema}
                        className="col-lg-4"
                        object={object}
                        disabled={true}
                        onChange={this.onChange.bind(this)}
                        excludeFields={[
                          ...attachementsFields,
                          "user",
                          "location",
                          "examDate",
                          "reference",
                          "positionTitle",
                          "status",
                        ]}
                      />

                      {/* <Divider title={"Additional Information"} /> */}
                      <ul
                        className="row mt-5"
                        style={{
                          fontFamily:
                            '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                          fontSize: "14px",
                        }}
                      >
                        <li style={{ fontWeight: 600 }}>
                          Are you related by consanguinity or affinity to the
                          appointing or recommending authority, or to the chief
                          of bureau of office or the person who has immediate
                          supervision over you in the Office, Bureau or
                          Department where you will be appointed,
                        </li>
                        <div className="row mt-1">
                          {qDefs
                            .slice(0, 3)
                            .map((q) =>
                              q.kind === "child"
                                ? this.toggleItemChildList(
                                    q.label,
                                    this.state[q.key],
                                    q.key,
                                    object,
                                    { disabled: viewDisabled },
                                  )
                                : this.toggleItemParentList(
                                    q.label,
                                    this.state[q.key],
                                    q.key,
                                    object,
                                    { disabled: viewDisabled },
                                  ),
                            )}

                          <li>
                            <div className="row">
                              <p className="col-lg-6 d-flex align-items-center mt-2">
                                B. Have you been criminally charge before any
                                court?
                              </p>
                              <button
                                type="button"
                                className="btn col-lg-3 w-auto p-0 me-5 border-0 bg-transparent shadow-none"
                                disabled={viewDisabled}
                                onClick={() => {
                                  if (viewDisabled) return;
                                  this.handleToggleState("questionFour");
                                }}
                              >
                                <i
                                  className={`text-center ${
                                    this.state.questionFour
                                      ? "bi bi-toggle-on"
                                      : "bi bi-toggle-off"
                                  }`}
                                  style={{ zoom: 1.5, padding: 0 }}
                                ></i>
                              </button>
                              <div
                                className={`col-lg-5 ${
                                  this.state.questionFour ? "" : "d-none"
                                } d-flex align-items-center`}
                              >
                                <InputFactory
                                  uppercase
                                  placeholder="Please give details"
                                  type="String"
                                  object={object}
                                  field="questionFour"
                                  disabled={viewDisabled}
                                  onChange={this.onChange.bind(this)}
                                />
                                <InputFactory
                                  uppercase
                                  placeholder="Please give details"
                                  type="Date"
                                  object={object}
                                  field="questionFourDate"
                                  disabled={viewDisabled}
                                  onChange={this.onChange.bind(this)}
                                />
                                <InputFactory
                                  uppercase
                                  placeholder="Status of Case/s"
                                  type="String"
                                  object={object}
                                  field="questionFourStat"
                                  disabled={viewDisabled}
                                  onChange={this.onChange.bind(this)}
                                />
                              </div>
                            </div>
                          </li>

                          {qDefs
                            .slice(3, 8)
                            .map((q) =>
                              this.toggleItemParentList(
                                q.label,
                                this.state[q.key],
                                q.key,
                                object,
                                { disabled: viewDisabled },
                              ),
                            )}

                          <li style={{ fontWeight: 600 }}>
                            Pursuant to: (a) Indigenous People’s Act (RA 8371);
                            (b) Magna Carta for Disabled Persons (RA 7277); and
                            (c) Solo Parents Welfare Act of 2000 (RA 8971),
                            please answer the following items:
                          </li>

                          {qDefs
                            .slice(8)
                            .map((q) =>
                              this.toggleItemChildList(
                                q.label,
                                this.state[q.key],
                                q.key,
                                object,
                                { disabled: viewDisabled },
                              ),
                            )}
                        </div>
                      </ul>
                    </>
                  )}
                  <div className="mt-4 mb-4 row gap-4 border p-4">
                    <div className="w-100">
                      <div className="row">
                        {attachementsFields.map((item) => {
                          const field = this?.state?.object[item] || "";
                          console.log("field:", field);
                          return (
                            <div
                              className="d-grid col-lg-4 pt-2 pb-3 ps-5"
                              key={item}
                            >
                              {/* <label style={{ fontWeight: "bold" }}>
                                  {schema?.fields[item]
                                    ? schema?.fields[item]?.label
                                    : ""}
                                </label> */}
                              {Array.isArray(field) ? (
                                // If field is an array, render each link separately
                                field?.map((url, index) => {
                                  return (
                                    <a
                                      href={url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      key={index}
                                    >
                                      {schema?.fields[item]
                                        ? schema?.fields[item]?.label
                                        : ""}
                                    </a>
                                  );
                                })
                              ) : (
                                // If field is a single URL, render it directly
                                <p>
                                  {schema?.fields[item]
                                    ? schema?.fields[item]?.label
                                    : ""}
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* {Object.keys(certificateFields).map((item) => {
                        console.log("ITEM::::: ", item);
                        const location = certificateFields[item];
                        return (
                          <a
                            target="blank"
                            href={location}
                            className="col-lg-3"
                          >
                            {item}
                          </a>
                        );
                      })} */}
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={this.onClickBack.bind(this)}
                  >
                    GO BACK
                  </button>
                </div>
                {/* </form> */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobApplicantsView);
